// eslint-disable-next-line
export default {
    apiKey: 'AIzaSyC_JHe_PEw7gpcZ_BlDp9rq2-Scu4CvcC8'
}